import React, { useState, useEffect } from "react";
import { MdClose, MdWarning } from "react-icons/md";
import PreviewTable from "./PreviewTable";
import ValidationResults from "./ValidationResults";

export default function PreviewModal({
  isOpen,
  onClose,
  data,
  config,
  validationResults,
  onConfirm,
  isUploading = false,
}) {
  const [showUpdateWarning, setShowUpdateWarning] = useState(false);

  // 모달이 열릴 때마다 경고 상태 리셋
  useEffect(() => {
    if (isOpen) {
      setShowUpdateWarning(false);
    }
  }, [isOpen]);

  const handleUploadClick = () => {
    // 기존 수정이 있는지 확인
    if (validationResults?.summary.update > 0) {
      setShowUpdateWarning(true);
    } else {
      // 기존 수정이 없으면 바로 실행
      onConfirm();
    }
  };

  const handleFinalConfirm = () => {
    setShowUpdateWarning(false);
    onConfirm();
  };

  const handleCancelWarning = () => {
    setShowUpdateWarning(false);
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal-backdrop"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        className="modal-content bg-white rounded shadow-lg"
        style={{
          width: "95vw",
          maxWidth: "1200px",
          height: "90vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Modal Header */}
        <div className="modal-header d-flex justify-content-between align-items-center p-3 border-bottom">
          <h5 className="modal-title mb-0">📋 엑셀 업로드 미리보기</h5>
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={onClose}
            disabled={isUploading}
          >
            <MdClose size={20} />
          </button>
        </div>

        {/* Modal Body */}
        <div
          className="modal-body flex-grow-1 p-3"
          style={{ overflow: "auto" }}
        >
          {/* 검증 결과 */}
          {validationResults && (
            <ValidationResults results={validationResults} config={config} />
          )}

          {/* 미리보기 테이블 */}
          {data.length > 0 && (
            <PreviewTable
              data={data}
              config={config}
              validationResults={validationResults}
            />
          )}
        </div>

        {/* Modal Footer */}
        <div className="modal-footer p-3 border-top">
          {showUpdateWarning ? (
            // 업데이트 경고 상태
            <div className="d-flex justify-content-between w-100">
              <div className="alert alert-warning mb-0 p-1">
                <div className="d-flex align-items-start">
                  <MdWarning
                    className="text-warning me-2 mt-1 flex-shrink-0"
                    size={20}
                  />
                  <div>
                    <span>
                      기존 수정은 존재하는 기존 데이터를 업로드한 파일의
                      항목으로 <strong>모두 덮어쓰기</strong> 됩니다. <br />
                      한번 실행 후 되돌릴 수 없으니 신중히 실행해 주세요.
                      <span className="fw-bold ms-4">실행하시겠습니까?</span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end gap-2">
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleCancelWarning}
                  disabled={isUploading}
                >
                  취소
                </button>
                <button
                  className="btn btn-danger"
                  onClick={handleFinalConfirm}
                  disabled={isUploading}
                >
                  {isUploading ? (
                    <>
                      <div className="spinner-border spinner-border-sm me-2" />
                      업로드 중...
                    </>
                  ) : (
                    <>🚀 최종 실행</>
                  )}
                </button>
              </div>
            </div>
          ) : (
            // 기본 상태
            <div className="d-flex justify-content-end gap-2 w-100">
              <button
                className="btn btn-outline-secondary"
                onClick={onClose}
                disabled={isUploading}
              >
                취소
              </button>
              <button
                className="btn btn-success"
                onClick={handleUploadClick}
                disabled={validationResults?.errors.length > 0 || isUploading}
              >
                {isUploading ? (
                  <>
                    <div className="spinner-border spinner-border-sm me-2" />
                    업로드 중...
                  </>
                ) : (
                  <>📤 {validationResults?.summary.total}개 행 업로드 실행</>
                )}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
